import { PureLightTheme } from "../../styles/theme"
import { COLORS } from "../../styles/variables"

export const MainStack = {
    maxWidth: '736px',
    width: '100%',
    height: '100%',
}

export const FilterList = {
    padding: "20px 20px 14px 20px",
    // height: '100%',
    minHeight: '500px',
    [PureLightTheme.breakpoints.down("md")]: {
        padding: "10px 0px 0px 0px",
        overflowY: "auto",
        flex: 1, 
    }
}

export const CommentsListBox = {
    flexGrow: 1, 
    overflowY: 'auto', 
    minHeight: 0, 
    px: 1.5,
    pb: 1.5,
}

export const MobileReplyBox = {
    background: COLORS.SNOW_DRIFT, 
    border: `1px solid ${COLORS.LINK_WATER}`,
    borderBottom: 'none',
    borderRadius: "20px",
    '@media (max-width:736px)': {
        borderRadius: "0px",
        borderLeft: 'none',
        borderRight: 'none',
    },
}
